<template>
  <el-row>
    <el-col :span="12">
      <div class="content-item flex content-item-categorys">
        <div class="content-item-label">类目</div>
        <div class="category-tab-list flex">
          <div class="top-wrap">
            <span
              class="category-tab category-tab-add"
              @click="openDeseaseDialog"
              >添加类目</span
            >
          </div>

          <div class="cate-tab-wrap">
            <span
              class="category-tab"
              v-for="(item, index) in categorys"
              :key="index"
            >
              {{ item.categoryName + "(" + item.categoryId + ")" }}
              <img src="~_img/off.png" alt="del" @click="delCategory(index)" />
            </span>
          </div>
        </div>
        <!-- <p>给文章打上相关的类目，可以帮您更好的展示文章</p> -->
        <modal
          :isShow.sync="dialogDeseaseVisible"
          :title="dialogTitles"
          :btnText="btnText"
          :isShowBtn="isShowBtn"
          :width="dialogWidth"
          @clickHandler="clickHandler"
        >
          <div class="search-dialog-wrap">
            <el-input
              placeholder="请输入类目ID"
              v-model="searchCategoryName"
              class="input-with-select"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="queryCategory"
                class="search-but"
                >搜索</el-button
              >
            </el-input>
            <div class="search-desease-body">
              <div class="search-data">
                <el-checkbox-group
                  v-model="searchCategoryChecked"
                  v-if="searchCategoryList.length && !isShowSearchNoData"
                  @change="searchCategoryChange"
                >
                  <el-checkbox
                    :label="item.categoryId"
                    v-for="(item, index) in searchCategoryList"
                    :key="index"
                    >{{
                      item.categoryName + "(" + item.categoryId + ")"
                    }}</el-checkbox
                  >
                </el-checkbox-group>
              </div>
              <div
                class="noData flex flex-direction-column justify-content-center align-items-center"
                v-if="isShowSearchNoData"
              >
                <img src="~_img/search-noData.png" alt="没有数据" />
                <p class="errorInfo">很抱歉，暂未收录相关类目</p>
              </div>
            </div>
          </div>
        </modal>
      </div>
    </el-col>

    <el-col :span="12">
      <div class="large-tab-wrap">
        <!-- <div>{{largeModelLabels}}</div> -->
        <span
          :class="item.isSelected ? 'large-tab selected' : 'large-tab'"
          v-for="(item, index) in largeModelLabels"
          :key="index"
          @click="clickLargeModel(item)"
        >
          <i :class="item.isSelected ? `el-icon-check` : `el-icon-plus`"></i>
          {{ item.labelValue }}
        </span>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { request } from "@/utils/axios";
import modal from "@/components/modal";
export default {
  name: "categoryLabel",
  props: ["data", "functionIds", "largeModelLabelBizDTOS"],
  data() {
    return {
      deseaseTips: false,
      dialogDeseaseVisible: false, //添加类目弹窗
      isShowSearchNoData: false,
      searchCategoryName: "",
      searchCategoryList: [],
      searchCategoryListHistory: [],
      searchCategoryChecked: [],
      categorys: [],
      dialogTitles: "搜索类目",
      btnText: ["取消", "确认"],
      dialogWidth: "480px",
      isShowBtn: [true, true],
      largeModelLabels: [],
    };
  },
  components: {
    modal,
  },
  watch: {
    largeModelLabelBizDTOS(val) {
      this.largeModelLabels = val;
      if (this.categorys.length > 0) {
        this.largeModelLabels = this.largeModelLabels.map((lItem) => {
          const findRes = this.categorys.find((sItem) => {
            return sItem.categoryId == lItem.labelId;
          });
          if (findRes) {
            lItem.isSelected = true;
          }
          return lItem;
        });
      }
    },
    data(val) {
      this.searchCategoryChecked = [];
      if (val) {
        for (let i = 0; i < val.length; i++) {
          this.searchCategoryChecked.push(val[i].categoryId);
        }
      }
      this.categorys = val;
      val.map((item) => {
        this.searchCategoryListHistory.push(item);
      });
      if (this.largeModelLabels.length > 0) {
        this.largeModelLabels = this.largeModelLabels.map((lItem) => {
          const findRes = this.categorys.find((sItem) => {
            return sItem.categoryId == lItem.labelId;
          });
          if (findRes) {
            lItem.isSelected = true;
          }
          return lItem;
        });
      }
    },
  },
  created() {
    // this.categorys=this.data;
  },
  methods: {
    clickHandler(val) {
      if (val == "one") {
        this.dialogDeseaseVisible = false;
      }
      if (val == "two") {
        this.addCategorys();
        this.$emit("changeCategoryLabels", this.categorys);
      }
    },
    //打开类目标签弹窗
    openDeseaseDialog() {
      this.dialogDeseaseVisible = true;
      this.isShowSearchNoData = false;
      this.searchCategoryList = [];
      this.searchCategoryName = "";
    },
    // 获取选中的类目标签
    searchCategoryChange() {
      if (this.searchCategoryChecked && this.searchCategoryChecked.length > 3) {
        this.$message.error("类目标签最多选3个~");
        this.searchCategoryChecked.pop();
      }
    },
    getSearchCategoryListData() {
      let array = this.searchCategoryListHistory.filter((item) => {
        return this.searchCategoryChecked.some((i) => {
          return i == item.categoryId;
        });
      });
      let _map = [];
      return array.filter((item) => {
        if (!_map.includes(item.categoryId)) {
          _map.push(item.categoryId);
          return true;
        } else {
          return false;
        }
      });
    },
    //添加类目
    addCategorys() {
      if (this.searchCategoryChecked.length > 3) {
        return;
      }
      let dataList = this.getSearchCategoryListData();
      const isAdd = this.categorys.length < dataList.length;
      this.categorys = this.categorys || [];
      this.categorys.splice(0, this.categorys.length, ...dataList);
      this.dialogDeseaseVisible = false;
      // 处理 大模型选中
      if (isAdd) {
        this.largeModelLabels = this.largeModelLabels.map((lItem) => {
          const findRes = this.categorys.find((sItem) => {
            return sItem.categoryId == lItem.labelId;
          });
          if (findRes) {
            lItem.isSelected = true;
          }
          return lItem;
        });
      } else {
        this.largeModelLabels = this.largeModelLabels.map((lItem) => {
          const findRes = this.categorys.find((sItem) => {
            return sItem.categoryId == lItem.labelId;
          });
          if (!findRes) {
            lItem.isSelected = false;
          }
          return lItem;
        });
      }
    },
    delCategory(index) {
      this.categorys.splice(index, 1);
      this.searchCategoryChecked.splice(index, 1);
      // 处理 大模型选中
      this.largeModelLabels = this.largeModelLabels.map((lItem) => {
        const findRes = this.categorys.find((sItem) => {
          return sItem.categoryId == lItem.labelId;
        });
        if (!findRes) {
          lItem.isSelected = false;
        }
        return lItem;
      });
    },
    // 搜索类目
    queryCategory() {
      if (this.searchCategoryName) {
        request(this.functionIds.getCategorys, {
          categoryIds: [this.searchCategoryName],
        })
          .then((res) => {
            if (res && res.length) {
              this.isShowSearchNoData = false;
              this.searchCategoryList = res;
              res.map((item) => {
                this.searchCategoryListHistory.push(item);
              });
            } else {
              this.isShowSearchNoData = true;
            }
          })
          .catch((err) => {
            this.isShowSearchNoData = true;
          });
      } else {
        this.isShowSearchNoData = true;
      }
    },
    // 选中大模型
    clickLargeModel(item) {
      if (
        this.searchCategoryChecked &&
        this.searchCategoryChecked.length == 3 &&
        item.isSelected == false
      ) {
        this.$message.error("类目标签最多选3个~");
        return;
      }
      console.log("点击了----------------》", item, this.largeModelLabels);
      this.largeModelLabels = this.largeModelLabels.map((largeItem) => {
        console.log(
          largeItem.labelId,
          item.labelId,
          "点击了----------------》",
          item.labelId == largeItem.labelId
        );
        if (item.labelId == largeItem.labelId) {
          largeItem.isSelected = !largeItem.isSelected;
          console.log("点击了----------------》22222222", item.isSelected);
          // 如果是选中状态
          if (item.isSelected) {
            // 选中
            const rightItem = {
              categoryId: item.labelId,
              categoryName: item.labelValue,
              categoryClass: item.categoryBizDTO.categoryClass,
              fatherCategoryId: item.categoryBizDTO.fatherCategoryId,
              categoryNameAlias: item.categoryBizDTO.categoryNameAlias,
            };
            this.categorys = [...this.categorys, rightItem];
          } else {
            // 取消选中
            this.categorys = this.categorys.filter((fItem) => {
              return fItem.categoryId != item.labelId;
            });
          }
          this.$emit("changeCategoryLabels", this.categorys);
        }
        return largeItem;
      });
    },
    clickOnceApply(applyStatus) {
      if (applyStatus) {
        //  判断现在有多少个
        let addCount = 3 - this.searchCategoryChecked.length;
        // 去重复
        // const sameCount = this.largeModelLabels.filter((largeItem)=> largeItem.isSelected);
        // addCount = addCount + sameCount.length;
        this.largeModelLabels = this.largeModelLabels.map((largeItem) => {
          if (!largeItem.isSelected && addCount > 0) {
            largeItem.isSelected = true;
            addCount--;
            const rightItem = {
              categoryId: largeItem.labelId,
              categoryName: largeItem.labelValue,
              categoryClass: largeItem.categoryBizDTO.categoryClass,
              fatherCategoryId: largeItem.categoryBizDTO.fatherCategoryId,
              categoryNameAlias: largeItem.categoryBizDTO.categoryNameAlias,
            };
            this.categorys = [...this.categorys, rightItem];
          }
          return largeItem;
        });
      } else {
        // 一键取消
        this.largeModelLabels = this.largeModelLabels.map((largeItem) => {
          // 相等 删除
          this.categorys = this.categorys.filter((fItem) => {
            if (largeItem.labelId == fItem.categoryId) {
              largeItem.isSelected = false;
            }
            return fItem.categoryId != largeItem.labelId;
          });
          return largeItem;
        });
      }
      this.$emit("changeCategoryLabels", this.categorys);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/dialog_common.scss";
$color: #266cee;

// .content-item-categorys {
//   // width: 225px;
//   // min-width: 225px!important;
// }
.input-with-select {
  width: 437px !important;
  padding-bottom: 4px !important;
}
//类目搜索
.search-dialog-wrap {
  min-height: 138px;
  margin: 20px;
  .search-data {
    max-height: 138px;
    overflow: hidden;
    overflow-y: auto;
    margin-top: 20px;
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-thumb {
      width: 4px;
      height: 30px;
      background-color: #989ca5;
    }
    .el-checkbox {
      margin-right: 24px;
    }
    .el-checkbox__label {
      color: #262626;
      padding-left: 6px;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background: $color;
      border-color: $color;
    }
    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #262626;
    }
    .el-checkbox__inner:hover {
      border-color: $color;
    }
  }
  .noData {
    img {
      width: 121px;
      height: 78px;
      border: none;
    }
    p {
      font-size: 12px;
      color: #9a9a9a;
      margin-top: 20px;
    }
  }
}
.have {
  cursor: pointer;
}
.btns {
  padding-bottom: 22px;
  padding-top: 40px;
  line-height: 0px !important;
}
.dialog-but {
  padding-top: 9px;
}
:deep(.button) {
  line-height: 0px !important;
}
:deep(.content-item) {
  min-width: 100% !important;
}
:deep(.el-button .el-button--primary) {
  padding-top: 10px;
}
.search-but {
  padding-top: 8px;
}
.errorInfo {
  width: 145px !important;
  text-align: right;
  margin-right: 10px;
}
.desease-tips {
  width: 147px !important;
  height: 20px;
  position: absolute;
  left: 878px;
  top: 0;
}
.category-tab-add {
  width: 105px !important;
  position: absolute !important;
  left: 0px;
  top: -37px;
}
.category-tab-list {
  // position: relative !important;
  flex-direction: column !important;
  s .cate-tab-wrap {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    //  gap: 20px;
  }

  .category-tab {
    display: inline-block;
    height: 32px;
    line-height: 32px;
    text-align: center;
    // background: rgba(255, 110, 0, 0.12);
    border: 1px solid #0058ee;
    border-radius: 2px;
    padding: 0 16px;
    margin-right: 28px;
    // margin-top: 35px !important;
    cursor: pointer;
    // color: #FF6E00;
    color: #0058ee;
    position: relative;
    margin-bottom: 10px;

    img {
      position: absolute;
      top: -8px;
      right: -8px;
      width: 15px;
      height: 15px;
      background-size: 15px;
    }
  }
  .category-tab-add {
    position: static !important;
    border: 1px dashed rgba(154, 154, 154, 1);
    background: rgba(255, 255, 255, 1);
    color: rgba(38, 38, 38, 1);
    &::before {
      content: "";
      display: inline-block;
      width: 12px;
      height: 12px;
      background: url("~_img/add.png") no-repeat;
      background-size: 12px;
    }
    &::after {
      display: none;
    }
  }

  .top-wrap {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .category-tab {
      display: inline-block;
      height: 32px;
      line-height: 32px;
      text-align: center;
      border-radius: 2px;
      padding: 0 16px;
      margin-right: 28px;
      cursor: pointer;
      position: relative;
      img {
        position: absolute;
        top: -8px;
        right: -8px;
        width: 15px;
        height: 15px;
        background-size: 15px;
      }
    }
  }
}

.large-tab-wrap {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;

  .large-tab {
    display: inline-block;
    height: 32px;
    line-height: 32px;
    text-align: center;
    border: 1px solid #ffa400;
    border-radius: 2px;
    padding: 0 16px;
    margin-right: 28px;
    cursor: pointer;
    color: #ffa400;
    margin-bottom: 20px;
    font-size: 14px;
    img {
      position: absolute;
      top: -8px;
      right: -8px;
      width: 15px;
      height: 15px;
      background-size: 15px;
    }
    &.selected {
      border: 1px solid rgba(195, 195, 195, 1);
      color: #ffffff;
      background-color: rgba(195, 195, 195, 1);
    }
  }
}
</style>
